import { useGetAiMappingRunLazyQuery } from "generated/graphql";

export default function useGetAiMappingRun() {
  const [fetch, { data, loading, error }] = useGetAiMappingRunLazyQuery();
  return [fetch, { data, loading, error }] as const;
}
